exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ProfileImage {\r\n  max-width: 200px;\r\n  max-height: 200px;\r\n}\r\n\r\n.quotationTable tbody tr:hover {\r\n  cursor: pointer;\r\n}\r\n\r\ntemplate modal-body {\r\n  background-image: image('assets/img/logoEnd.png');\r\n}\r\n\r\n.dataPresent:nth-child(even) {\r\n  background-color: rgba(70, 127, 191, 0.5) !important;\r\n}\r\n\r\nmat-expansion-panel .personalData tr {\r\n  line-height: 54px;\r\n}\r\n\r\nmat-expansion-panel .personalData tr:hover {\r\n  background: rgba(70, 127, 191, 0.6);\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/PRO/Documents/GitHub/CGStore-Front/src/app/auth/profile/profile.component.css
// module id = ../../../../../src/app/auth/profile/profile.component.css
// module chunks = main